import { RiArrowDropLeftLine, RiArrowDropRightLine } from 'react-icons/ri';
import { Button, Col, Row, TabPane } from 'reactstrap';
import { FaPortrait } from 'react-icons/fa';
import { FcPortraitMode } from 'react-icons/fc';
import { BsPersonBoundingBox, BsPersonBadge } from 'react-icons/bs';

interface PreparationSelfieProps {
  handleChangeTabe: (tab: string) => void;
}

const PreparationSelfie: React.FC<PreparationSelfieProps> = ({
  handleChangeTabe,
}) => {
  return (
    <TabPane tabId="6">
      <Row className="mb-2">
        <Col className="text-center">
          <BsPersonBadge size={150} style={{ color: '#7367f0' }} />
        </Col>
      </Row>
      <Row className="mb-2">
        <Col className="text-center">
          <h2 className="text-primary">Hora da selfie!</h2>
          <p className="text-start">
            Clique no botão abaixo quando estiver pronto para tirar a selfie.
          </p>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col className="text-center">
          <Button color="warning" onClick={() => handleChangeTabe('7')}>
            Estou pronto!
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <Button
            size="sm"
            color="secondary"
            onClick={() => handleChangeTabe('3')}
          >
            <RiArrowDropLeftLine size={25} /> Anterior
          </Button>
          <Button
            size="sm"
            color="success"
            disabled
            style={{ cursor: 'not-allowed' }}
          >
            Próximo <RiArrowDropRightLine size={25} />
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default PreparationSelfie;
